window.$ = window.jQuery = require("jquery");
$.mask = window.mask = require("jquery-mask-plugin");
LazyLoad = require("vanilla-lazyload");
require("bootstrap/js/dist/modal");
require("owl.carousel");

require("lightgallery");
require("lg-zoom");
require("lg-fullscreen");
require("lg-video");

const $window = $(window);

window.optionsLG = {
  controls: false,
  download: false,
  youtubePlayerParams: {
    modestbranding: 1,
    showinfo: 0,
    rel: 0,
    controles: 0,
  },
};

// CHAVES GMAPS
var key_gmaps_1 = "AIzaSyDhTJDx2sXVDA4xQbYOtWgkdvLspWgybvY"; // prod
window.key_gmaps = "AIzaSyB8H7PGo8gAbA8o_rwODadh3I6Ea27e8zE"; // dev

// BREAKPOINTS
var md = 1200,
  ww = $window.width();
window.tablet = ww >= 768 && ww < md;
window.desk = ww > md;

if (
  location.href.indexOf("setin.com.br") > 0 ||
  location.href.indexOf("setinvendas.com.br") > 0
) {
  window.key_gmaps = key_gmaps_1;
}

$(function () {
  new LazyLoad({ elements_selector: ".lazy" });

  const ww = $window.width();

  // MENU FIXO
  if (ww >= 1024) {
    if ($window.scrollTop() > 100) {
      $("body").addClass("menu-fixo");
    }

    $window.on("scroll", function () {
      if ($(this).scrollTop() > 100) $("body").addClass("menu-fixo");
      else $("body").removeClass("menu-fixo");
    });
  }

  // BTN MENU
  $(".btn-menu, .menu .btn-close").on("click", function () {
    $("body").toggleClass("menu-open");
  });

  // BTN CONTATO
  $(".js-open-form, .modal-contato .btn-close").on("click", function (e) {
    e.preventDefault();
    $("body").toggleClass("modal-form-open");
  });

  //BTN INVESTIR
  $(".investir .js-plus").on("click", function () {
    let $item = $(this).parent();
    $item.toggleClass("show");
  });

  //ZOOM
  //$('.carrossel').lightGallery(Object.assign({ selector: '.item a' }, optionsLG));

  // NAV SCROLLTO
  $(".menu nav a:not(.destaque)").on("click", function (e) {
    e.preventDefault();
    let hash = $(this).attr("href"),
      $el = $(hash),
      pos = $el.offset().top;

    pos = ww >= 1024 ? pos - 59 : pos;

    $el.removeAttr("id");
    $("body").removeClass("menu-open");

    $("body,html").animate({ scrollTop: pos }, 500, function () {
      location.hash = hash;
      $el.attr("id", hash.replace("#", ""));
    });
  });

  $("header .logo").on("click", function () {
    $("body,html").animate({ scrollTop: 0 }, 500);
    history.pushState(
      "",
      document.title,
      window.location.pathname + window.location.search
    );
  });

  // MASCARA
  $("input[data-mask=tel]:not(:disabled)").each(function (i, el) {
    $(el).mask(SPMaskBehavior, spOptions);
  });

	// ESCOLHA FORMA CONTATO
	$('#Forma_Contato_1 , #Forma_Contato_2, #Forma_Contato_3').on('change', function() {
		let
			tipo = '.form-' + $(this).val(),
			form = $(this).parents('.form');

		$('form', form).addClass('d-none');
		$(tipo, form).removeClass('d-none');

		$('.form', form).removeClass('form-sending form-sucess');
		$('.msg', form).removeClass('msg-ativo');
	})

	// VALIDANDO CHECKBOX DE ACEITE
    $("input[name=Aceito_Contato_Email],input[name=Aceito_Contato_WhatsApp],input[name=Aceito_Contato_Telefone]").each(function (i, el) {
		el.setCustomValidity("invalido");
	  });
	  $('input[name=Aceito_Contato_Email], input[name=Aceito_Contato_WhatsApp], input[name=Aceito_Contato_Telefone]').on('change', function() {
		var $form = $(this).parents('form');
		if ($('input[name=Aceito_Contato_Email]', $form).get(0).checked || $('input[name=Aceito_Contato_WhatsApp]', $form).get(0).checked || $('input[name=Aceito_Contato_Telefone]', $form).get(0).checked) {
			
		  $("input[name=Aceito_Contato_Email],input[name=Aceito_Contato_WhatsApp],input[name=Aceito_Contato_Telefone]",$form).each(function (i, el) {
			el.setCustomValidity("");
		});
  
		} else {
		  $("input[name=Aceito_Contato_Email],input[name=Aceito_Contato_WhatsApp],input[name=Aceito_Contato_Telefone]").each(function (i, el) {
			el.setCustomValidity("invalido");
		  });
		}
	  })

  // WHATSAPP
  $("input[data-mask-tel]:not(:disabled)").each(function (i, el) {
    $(el).mask(SPMaskBehavior, spOptions);
  });

  $(".input_whats_mascara").on("input", function () {
  let inputWhats = $(this).val();
  let btnWhats = $('#btn_whats_mascara');
  let btnWhatsDesk = $('#btn_whats_mascara_desk');
  if (inputWhats.length >= 15) {
    btnWhats.prop('disabled', false);
    btnWhatsDesk.prop('disabled', false);
  } else {
    btnWhats.prop('disabled', true);
    btnWhatsDesk.prop('disabled', true);
  }
  });

  window.toggleWhatsAppDialog = () => {
  let dialog = $('#whatsappDialog');
  if (!dialog.length) {
    console.error("Elemento #whatsappDialog não encontrado.");
    return;
  }
  dialog.css('display', (dialog.css('display') === 'none' || dialog.css('display') === '') ? 'flex' : 'none');
  };

  window.openWhatsApp = (e) => {
    var origem = '';
    var ref_raw = '';
    var referrer = '';
    var history_id = '';
    var pagina = '';
    var masckWhats = '';
    if(document.getElementById('whatsappNumber')){
      masckWhats = document.getElementById('whatsappNumber');
    }
    if(document.getElementById('whatsappNumberMob')){
      masckWhats = document.getElementById('whatsappNumberMob');
    }

    let dialog = document.getElementById('whatsappDialog');
    if (!dialog) {
      console.error("Elemento #whatsappDialog não encontrado.");
      return;
    }

    dialog.style.display = (dialog.style.display === 'none' || dialog.style.display === '') ? 'flex' : 'none';
    
    let whatsappLink = 'https://api.whatsapp.com/send?phone=551130414646&text=Ol%C3%A1%2C%20gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20um%20apartamento%20da%20Setin'
    window.open(whatsappLink, '_blank');
    if (cookie.get("hubid_rawref")) {
      var cookie_hubid_rawref = JSON.parse(
      atob(cookie.get("hubid_rawref"))
      );
      origem = cookie_hubid_rawref.origem ? cookie_hubid_rawref.origem : "";
      ref_raw = cookie_hubid_rawref.url ? cookie_hubid_rawref.url : "";
      referrer = cookie_hubid_rawref.referrer ? cookie_hubid_rawref.referrer : "";
    }

    if (cookie.get("hubid_user")) {
      var cookie_hubid_user = JSON.parse(
      atob(cookie.get("hubid_user"))
      );
      history_id = cookie_hubid_user.history_id ? cookie_hubid_user.history_id : "";
    }
    if (cookie.get("hubid_visit")) {
      var cookie_hubid_visit = atob(cookie.get("hubid_visit")); // Decodifica Base64
      pagina = cookie_hubid_visit;
    }

    var settings = {
      "url": "https://setin.hubid360.com.br/api/leadphone",
      "method": "POST",
      "timeout": 0,
      "headers": {
      "Content-Type": "application/json"
      },
      "data": JSON.stringify({ 
      telefone: '55' + masckWhats.value.replace(/\D/g, ""),
      origem: origem,
      referencia: referrer || document.referrer,
      referencia_raw: ref_raw || document.location.href,
      historico_id: history_id.toString(),
      pagina: pagina || window.location.pathname}),
    };
    
    $.ajax(settings).done(function (response) {
      //console.log(response);
    });
  
  };

  // CARROSSEL
  if (ww < 1024) {
    $(".intro .destaque .itens").addClass("owl-carousel").owlCarousel({
      nav: false,
      dots: true,
      items: 1,
      margin: 20,
    });

    $(".dados-regiao .itens").addClass("owl-carousel").owlCarousel({
      nav: false,
      dots: true,
      items: 1,
      margin: 20,
    });

    $(".studios .itens").addClass("owl-carousel").owlCarousel({
      nav: false,
      dots: false,
      lazyLoad: true,
      lazyLoadEager: 1,
      items: 1,
      margin: 20,
    });
  }

  $(".galeria-regiao .itens").owlCarousel({
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-prev", "owl-next icon-next"],
    nav: false,
    dots: false,
    lazyLoad: true,
    lazyLoadEager: 2,
    items: 1,
    margin: 20,
    responsive: {
      1200: {
        margin: 60,
        nav: true,
        onTranslate: function (e) {
          $(".owl-item", e.target).removeClass("hide");
          $(".owl-item:lt(" + e.item.index + ")", e.target).addClass("hide");
        },
      },
    },
  });

  $(".diferenciais .itens").owlCarousel({
    nav: false,
    dots: true,
    items: 1,
    responsive: {
      1024: {
        items: 2,
      },
    },
  });

  $(".diferenciais .galeria").owlCarousel({
    navText: [],
    navElement: "div",
    navClass: ["owl-prev icon-prev", "owl-next icon-next"],
    nav: false,
    dots: true,
    items: 1,
    margin: 20,
    responsive: {
      1200: {
        nav: true,
        dots: false,
      },
    },
  });

  // POPUP COOKIE
  $(".popup-aviso-cookie button").on("click", function () {
    cookie.set("box_closed", true, 365);
    $(".popup-aviso-cookie").addClass("hide");
    setTimeout(() => {
      $(".popup-aviso-cookie").remove();
    }, 400);
  });

  // MAPA
  $(".localizacao-mapa .bt-explorar, #bt-confirmar-selecao").on(
    "click",
    function (e) {
      e.preventDefault();
      $(".localizacao-mapa .places").toggleClass("open");
      $(this).toggleClass("open");
    }
  );

  gmaps.init();
});

var SPMaskBehavior = function (val) {
    return val.replace(/\D/g, "").length === 11
      ? "(00) 00000-0000"
      : "(00) 0000-00009";
  },
  spOptions = {
    onKeyPress: function (val, e, field, options) {
      field.mask(SPMaskBehavior.apply({}, arguments), options);
    },
  };

// GA EVENTOS
window.eventos = function (categoria, acao, rotulo) {
  ga("send", "event", categoria, acao, rotulo);
};

/// VALIDACAO FORMULARIOS
(function () {
	'use strict';
	window.sendSafetyControl = false;
	window.addEventListener('load', function () {
		var forms = document.getElementsByClassName('needs-validation');
		var validation = Array.prototype.filter.call(forms, function (form) {
			form.addEventListener('submit', function (event) {
				var $form = $(form);
				var empreend = $form.data('empreend');
				var tipo = $form.data('tipo');

				if (form.checkValidity() === false) {
					event.preventDefault();
					event.stopPropagation();

					$('.form-control:invalid ~ .invalid-feedback', $form).each(function () {
						eventos('Contato', 'Erro', $(this).text());
					})

				} else {

					eventos('Contato', 'Enviar ' + tipo, empreend);

          window.dataLayer.push ({
            'event': 'Sucesso ' + tipo
          });

					// Integração Log
                    var $contato_email = $("input[name=Aceito_Contato_Email]", $form);
                    var $contato_zap = $("input[name=Aceito_Contato_WhatsApp]", $form);
                    var $contato_telefone = $("input[name=Aceito_Contato_Telefone]", $form);
					var origem = '';
					var ref_raw = '';
					var referrer = '';
					var dados = $('input,select,textarea', $form).filter(':not(disabled)').serialize();

					if (cookie.get('hubid_rawref')) {
						var cookie_hubid = JSON.parse(atob(cookie.get('hubid_rawref')));
						origem = cookie_hubid.origem ? cookie_hubid.origem : '';
						ref_raw = cookie_hubid.url ? cookie_hubid.url : '';
						referrer = cookie_hubid.referrer ? cookie_hubid.referrer : '';
					}

					$.ajaxSetup({
						headers: {
							'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
						}
					});
					$.ajax({
						type: "GET",
						url: "/api/empreendimentos/lead/",
						data: dados + '&empreend=' + empreend + '&title=' + document.title + '&Referencia=' + origem + '&ReferenciaRaw=' + encodeURIComponent(ref_raw) + '&Referrer=' + encodeURIComponent(referrer) + '&IP=' + window.ip_client + '&FormConf=' + tipo + '&Aceito_Contato_Email=' + ($contato_email.is(':checked') ? 'SIM' : '') + '&Aceito_Contato_WhatsApp=' + ($contato_zap.is(':checked') ? 'SIM' : '') + '&Aceito_Contato_Telefone=' + ($contato_telefone.is(':checked') ? 'SIM' : '') + '&Pagina=' + document.location.pathname ?? '',
						success: function (data) {
							if (data == 204) {
								console.log('Sucesso - Log');
							}
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.log(textStatus, errorThrown);
						}
					});
					// Fim Log

					if ($(form.Email).hasClass('nosafetymails')) {
						return validaSafetyMails($(form.Email), false);
					}
				}
				form.classList.add('was-validated');
			}, false);
		});
	}, false);

	$('input.nosafetymails')
		.on('input', function () {
			$(this).removeClass('valido erro is-invalid');
			$(this).get(0).setCustomValidity('');
			$(this).addClass('nosafetymails');
		})
		.on('blur', function () {
			if ($(this).is(':valid')) {
				var $this = $(this)
				setTimeout(function () {
					validaSafetyMails($this, true);
				}, 500)
			}
		})

	var password = document.getElementById("FC_Senha");
	var confirm_password = document.getElementById("FC_ConfirmarSenha");

	if (password != null) {

		function validatePassword() {
			if (password.value != confirm_password.value) {
				confirm_password.setCustomValidity("Senhas diferentes!");
			} else {
				confirm_password.setCustomValidity('');
			}
		}

		password.onchange = validatePassword;
		confirm_password.onkeyup = validatePassword;
	}

	// VALIDA SAFETY MAILS
	function validaSafetyMails($el, async) {
		if ($el.val().indexOf('teste@teste.com') >= 0) {
			$el.removeClass('nosafetymails erro is-invalid');
			$el.get(0).setCustomValidity('');
			return;
		}

		if (!$el.hasClass('validando') && !$el.hasClass('valido') && !$el.hasClass('erro')) {

			$el.addClass('validando');
			var $form = $el.parents('form');
			var email = b64EncodeUnicode($el.val());
			var key = 'be3c11605563fc1eecee6aa1fce057f81e988c55';
			var ticket = location.href.indexOf('dev.id360.net') > -1 ? 'ca24c6e65d29135199725ea61abde5a11424713d' : // dev
				location.href.indexOf('setin.com.br') > -1 ? '0d892add1b79e97fcc9b0f57bbeb43d8f6a3246f' : // prod
				'47255688e229bf0f2f920fb441dd520189fb5b27'; // local

			setTimeout(function () {
				$.ajax({
					dataType: "json",
					url: 'https://optin.safetymails.com/main/safetyapi/' + key + '/' + ticket + '/' + email,
					data: '',
					async: async,
					success: function (r) {
						console.warn('Status SafetyMails: ' + r.Status);
						if (r.Status == 'INVALIDO' || r.Status == 'ERRO_SINTAXE' || r.Status == 'SPAMTRAP_POSSIVEL' || r.Status == 'DOMINIO_INVALIDO') {
							$el.addClass('erro is-invalid');
							$el.get(0).setCustomValidity('Inválido!');
							console.error('email invalido');
						} else {
							$el.removeClass('nosafetymails erro is-invalid').addClass('valido');
							$el.get(0).setCustomValidity('');

							if ($form.find('input[name=validadoSafetyMails]').length > 0) {
								$form.find('input[name=validadoSafetyMails]').val('Sim');
							} else {
								console.error('Campo de controle do SafetyMails ausente');
							}
						}
					},
					error: function () {
						$el.removeClass('nosafetymails erro is-invalid').addClass('valido');
						$el.get(0).setCustomValidity('');
					},
					complete: function () {
						$el.removeClass('validando');

						if (window.sendSafetyControl) {
							$form.find('.btn').trigger('click');
						}
					}
				})
			}, 100);
		}
	}

	function b64EncodeUnicode(str) {
		return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
			function toSolidBytes(match, p1) {
				return String.fromCharCode('0x' + p1);
			}));
	}

})();

// INTEGRACAO HUBID
hubid_callback = function (state, form, channel, message) {
  var $form = $(form);
  var empreend = $form.data("empreend");
  var tipo = $form.data("tipo");
  var mensagem = "";
  var $container = $form.parents(".form");
  var $buttonSubmit = $form.find(".btn.btn-form");

  $buttonSubmit.prop('disabled', true).html('Enviando...');

  if ($form.find(".msg").length == 0) {
    $form.find("button.btn-form").after('<div class="msg"></div>');
  }

  var $msg = $container.find(".msg");

  $msg.on("click", function (e) {
    e.preventDefault();
    $msg.removeClass("msg-ativo");
    if ($container.hasClass("form-sucess")) {
      $(".modal.show").modal("hide");
    }
    $container.removeClass("form-sending form-sucess form-error");
    setTimeout(function () {
      $msg.html();
    }, 200);
  });

  switch (state) {
	case 'loading':
		// $container.addClass('form-sending');
		break;
	case 'error':
		$container.addClass('form-error');
		mensagem = "";
		$msg.addClass('msg-ativo');
		$msg.html('<h3>ERRO AO ENVIAR</h3><p>Informe o administrador do sistema.</p><a href="#" class="bt icon-close-line"></a>');
		break;
	case 'success':
		// $container.addClass('form-sucess');
		$form.removeClass('was-validated');
		// track facebook
		fbTrackEvent('Lead');

		// track pinterest
		pintrk('track', 'lead', {
			lead_type: 'Newsletter'
		});

		// track tiktok
		ttq.identify({
			email: form.Email.value,
			phone_number: '+55' + form.Telefone.value.replace(/\D/g, ""),
		})
		ttq.track('Contact');

		// track  GA
		eventos('Contato', 'Sucesso ' + tipo, empreend);

    $buttonSubmit.prop("disabled", false).html('Enviar');

		$form.get(0).reset();

		$form.removeClass('was-validated').find('.form-control').removeClass('valido erro erro-sintaxe');

		$msg.addClass('msg-ativo');
		$msg.html('<h3>DADOS ENVIADOS COM SUCESSO!</h3><p>Obrigado por entrar em contato.</p><a href="#" class="bt icon-close-line"></a>');

		if (channel.match(/(whatsapp|chat|videoconferencia)/)) {
			$('.form-sucess .msg .bt').trigger('click');
		}

  $("input[name=Aceito_Contato_Email],input[name=Aceito_Contato_WhatsApp],input[name=Aceito_Contato_Telefone]",$form).each(function (i, el) {
	el.setCustomValidity("invalido");
});

		break;
}
};

// COOKIES
window.cookie = {
  set: (name, value, days = 0, path = "/") => {
    let expires =
      days === 0 ? "" : new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name +
      "=" +
      value +
      "; expires=" +
      expires +
      "; path=" +
      path +
      "; SameSite=Lax;";
  },

  get: (name) => {
    return document.cookie.split("; ").reduce((r, v) => {
      const parts = v.split("=");
      return parts[0] === name ? parts[1] : r;
    }, null);
  },

  del: (name) => cookie.set(name, "", -1),
};

// GMAPS
gmaps = {
  coord: {},
  map_position: [],
  pin_position: [],
  map: [],
  panorama: null,
  loading: false,
  loaded: false,
  zoom: 17,
  image_pin: "/portal/img/pin.svg",
  places: {
    lazer: {
      status: false,
      grupos: [
        "park",
        "museum",
        "movie_theater",
        "movie_rental",
        "bowling_alley",
        "art_gallery",
        "aquarium",
        "shopping_mall",
      ],
      icone: "/portal/img/ico-places-lazer.svg",
      marcadores: [],
    },
    educacao: {
      status: false,
      grupos: ["school", "university", "library", "book_store"],
      icone: "/portal/img/ico-places-educacao.svg",
      marcadores: [],
    },
    gastronomia: {
      status: false,
      grupos: ["bakery", "bar", "cafe", "food", "restaurant", "meal_delivery"],
      icone: "/portal/img/ico-places-gastronomia.svg",
      marcadores: [],
    },
    saude: {
      status: false,
      grupos: [
        "hospital",
        "pharmacy",
        "health",
        "doctor",
        "dentist",
        "spa",
        "physiotherapist",
      ],
      icone: "/portal/img/ico-places-saude.svg",
      marcadores: [],
    },
    comodidade: {
      status: false,
      grupos: [
        "parking",
        "grocery_or_supermarket",
        "taxi_stand",
        "supermarket",
        "beauty_salon",
        "bank",
        "bus_station",
        "car_wash",
        "clothing_store",
        "electronics_store",
        "hardware store",
        "subway_station",
      ],
      icone: "/portal/img/ico-places-comodidade.svg",
      marcadores: [],
    },
  },

  init: function () {
    var coord = $(".mapa").data("coord").split(",");
    gmaps.coord = { lat: coord[0] * 1, lng: coord[1] * 1 };

    $(".places a, .zoom-mapa a, .visualizacao a").on("click", function (e) {
      e.preventDefault();
      gmaps.load_script(this, $("#canvas_map"), true);
    });

    $("#canvas_map").on("click", function (e) {
      gmaps.load_script(this, $(this), true);
    });
  },

  load_script: function (el_trigger, el_canvas, set_places) {
    if (gmaps.loading) return false;

    if (gmaps.loaded) {
      gmaps.loaded_script(el_trigger, el_canvas, set_places);
    } else {
      gmaps.loading = true;
      var sgmapsa = document.createElement("script"),
        sgmapsb = document.getElementsByTagName("script")[0];
      sgmapsa.src =
        "//maps.googleapis.com/maps/api/js?key=" +
        key_gmaps +
        "&v=3.exp&libraries=places";
      sgmapsb.parentNode.insertBefore(sgmapsa, sgmapsb);

      sgmapsa.onload = function () {
        gmaps.loading = false;
        gmaps.loaded = true;
        gmaps.loaded_script(el_trigger, el_canvas, set_places);
      };
    }
  },

  loaded_script: function (el_trigger, el_canvas, set_places) {
    if (set_places) {
      gmaps.pin_position[1] = new google.maps.LatLng(
        gmaps.coord.lat,
        gmaps.coord.lng
      );
      if (desk) {
        gmaps.map_position[1] = new google.maps.LatLng(
          gmaps.coord.lat,
          gmaps.coord.lng - 0.0027
        );
      } else {
        gmaps.map_position[1] = new google.maps.LatLng(
          gmaps.coord.lat + 0.0009,
          gmaps.coord.lng - 0.00045
        );
      }
    } else {
      gmaps.pin_position[2] = new google.maps.LatLng(
        gmaps.coord.lat,
        gmaps.coord.lng
      );
      gmaps.map_position[2] = new google.maps.LatLng(
        gmaps.coord.lat,
        gmaps.coord.lng
      );
    }

    el_canvas.off("click");

    if (set_places) $(".places a, .zoom-mapa a, .visualizacao a").off("click");

    gmaps.load_map(el_trigger, el_canvas, set_places, set_places ? 1 : 2);
  },

  load_map: function (el_trigger, el_canvas, set_places, i) {
    var options = {
      zoom: gmaps.zoom,
      scrollwheel: false,
      draggable: true,
      center: gmaps.map_position[i],
      disableDefaultUI: set_places,
      padding: {
        left: 50,
      },
    };

    var styles = [
      {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
    ];

    gmaps.map[i] = new google.maps.Map(el_canvas.get(0), options);

    if (set_places) gmaps.map[i].setOptions({ styles: styles });

    marker = new google.maps.Marker({
      map: gmaps.map[i],
      icon: gmaps.image_pin,
      position: gmaps.pin_position[i],
    });

    gmaps.panorama = gmaps.map[i].getStreetView();
    gmaps.panorama.setPosition(gmaps.pin_position[i]);

    if (set_places) {
      $(".places a").on("click", function (e) {
        e.preventDefault();
        var tipo = $(this).data("place");
        gmaps.load_places(tipo);
      });

      $(".zoom-mapa a").on("click", function (e) {
        e.preventDefault();
        var zoom = $(this).hasClass("zoom-mais") ? +1 : -1;
        gmaps.zooming(zoom);
      });

      $(".visualizacao a").on("click", function (e) {
        e.preventDefault();

        if ($(this).hasClass("ativo")) return false;

        $(this).addClass("ativo").siblings("a").removeClass("ativo");

        var tipo = $(this).data("tipo");

        gmaps.panorama.setVisible(false);

        switch (tipo) {
          case "satelite":
            gmaps.map[i].setMapTypeId(google.maps.MapTypeId.HYBRID);
            break;
          case "mapa":
            gmaps.map[i].setMapTypeId(google.maps.MapTypeId.ROADMAP);
            break;
          case "streetview":
            gmaps.panorama.setVisible(true);
            break;
        }
      });

      setTimeout(function () {
        $(el_trigger).trigger("click");
      }, 500);
    }
  },

  load_places: function (tipo) {
    if (gmaps.places[tipo].status) {
      gmaps.places[tipo].status = false;

      for (x = 0; x < gmaps.places[tipo].marcadores.length; x++) {
        gmaps.places[tipo].marcadores[x].setMap(null);
      }

      $(".places a[data-place=" + tipo + "]").removeClass("ativo");
    } else {
      gmaps.places[tipo].status = true;
      var request = {
        location: gmaps.pin_position[1],
        radius: 2000,
        types: gmaps.places[tipo].grupos,
      };
      var infowindow = new google.maps.InfoWindow();
      var service = new google.maps.places.PlacesService(gmaps.map[1]);
      service.nearbySearch(request, function (results, status) {
        if (status == google.maps.places.PlacesServiceStatus.OK) {
          for (var i = 0; i < results.length; i++) {
            gmaps.places[tipo].marcadores[i] = new google.maps.Marker({
              map: gmaps.map[1],
              position: results[i].geometry.location,
              icon: gmaps.places[tipo].icone,
              name: results[i].name,
            });
            google.maps.event.addListener(
              gmaps.places[tipo].marcadores[i],
              "click",
              function () {
                infowindow.setContent(this.name);
                infowindow.open(gmaps.map[1], this);
              }
            );
          }
          $(".places a[data-place=" + tipo + "]").addClass("ativo");
        }
      });
    }
  },

  zooming: function (z) {
    gmaps.zoom += z;
    gmaps.zoom = gmaps.zoom > 20 ? 20 : gmaps.zoom < 8 ? 8 : gmaps.zoom;
    gmaps.map[1].setZoom(gmaps.zoom);
  },
};
